import React, { useState, MouseEvent } from 'react'
import IconPickerPopover from './IconPickerPopover'
import NoteIcon from 'components/Notes/Icon'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import withSetNoteIcon from './withSetNoteIcon'

import IconButton from 'components/Utils/IconButton'

type IconOptions = {
  iconShape: string
  iconColor?: string
}

export type NoteIconWithPickerProps = {
  noteId: string
  iconShape: string
  iconColor: string
  setNoteIcon: (options: { id: string; input: IconOptions }) => void
}

const NoteIconWithPicker = ({
  noteId,
  iconShape,
  iconColor,
  setNoteIcon,
}: NoteIconWithPickerProps) => {
  const [isEditing, setIsEditing] = useState(false)

  const handleIsEditing = (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    setIsEditing(true)
    return false
  }

  const handleCancelEditing = () => setIsEditing(false)

  const handleIconChanged = ({
    iconColor: newIconColor,
    iconShape: newIconShape,
  }: IconOptions) => {
    setIsEditing(false)
    setNoteIcon({
      id: noteId,
      input: {
        iconColor: newIconColor,
        iconShape: newIconShape,
      },
    })
  }

  return (
    <TooltipOnHover
      id="note icon wrapper"
      placement="top"
      tooltipContent="Change icon"
    >
      <IconButton
        colorScheme="grayOnGray"
        boxSize="smaller"
        style={{
          marginLeft: 1,
          marginRight: 1,
        }}
        onClick={handleIsEditing}
      >
        <IconPickerPopover
          iconShape={iconShape}
          iconColor={iconColor}
          isEditingIcon={isEditing}
          onChange={handleIconChanged}
          onClickOutside={handleCancelEditing}
        >
          <NoteIcon size={16} iconShape={iconShape} iconColor={iconColor} />
        </IconPickerPopover>
      </IconButton>
    </TooltipOnHover>
  )
}

export default withSetNoteIcon(NoteIconWithPicker)
